import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-1 rtl:space-x-reverse">
      <Button
        variant={language === 'en' ? 'default' : 'outline'}
        size="sm"
        onClick={() => setLanguage('en')}
        className="text-xs font-medium min-w-[44px] min-h-[44px] px-3"
        aria-label="Switch to English language"
        aria-pressed={language === 'en'}
      >
        EN
      </Button>
      <Button
        variant={language === 'ar' ? 'default' : 'outline'}
        size="sm"
        onClick={() => setLanguage('ar')}
        className="text-xs font-medium min-w-[44px] min-h-[44px] px-3"
        aria-label="Switch to Arabic language - التبديل إلى اللغة العربية"
        aria-pressed={language === 'ar'}
      >
        ع
      </Button>
    </div>
  );
};

export default LanguageSwitcher;